import * as React from "react";
import { useParams } from "react-router-dom";
import { useGetIdentityQuery } from "../../store/api/identityApi";
import { IdentityDetailForm } from "./detailForm";
import { Loader } from "../../components/layout/loader";
import { IncorrectItem } from "../../components/generic/IncorrectItem/incorrectItem";
import { AccessRestrictedItem } from "../../components/generic/AccessRestrictedItem/accessRestrictedItem";
import { useGvcContextNavigation } from "../../reactHooks/useGvcContextNavigation";

type RouteParams = "org" | "gvc" | "identity";
export const IdentityDetailInitializer: React.FC = () => {
  const { org: orgName, gvc: gvcName, identity: identityName } = useParams<RouteParams>();
  useGvcContextNavigation("identity");

  const selfLink = `/org/${orgName}/gvc/${gvcName}/identity/${identityName}`;

  const { data: identity, isLoading, isFetching, isError, error, refetch } = useGetIdentityQuery(selfLink, {
    skip: !selfLink,
    refetchOnMountOrArgChange: true,
  });

  if (!identity && isLoading) {
    return <Loader />;
  }

  const is403 = isError && (error as any)?.status === 403;
  if (is403) {
    return <AccessRestrictedItem kind="identity" />;
  }

  const is404 = isError && (error as any)?.status === 404;
  if (is404 || !identity) {
    return <IncorrectItem kind="identity" canCreate={true} />;
  }

  return <IdentityDetailForm identity={identity} />;
};
